import type { VeoPlugin } from '../types';
import { hasWindow } from '../utils/safe-env';
import { definePlugin } from './plugin';

/**
 * Plugin que auto-emite `pageview` en cambios de ruta de una SPA.
 * Cubre `history.pushState`, `history.replaceState`, `popstate` y `hashchange`.
 */
export function spaRouterPlugin(): VeoPlugin {
  return definePlugin({
    name: 'spa-router',
    install(client) {
      if (!hasWindow()) return;

      // Pageview inicial.
      client.pageview();

      const fire = () => {
        // Diferir para que el router del host actualice location.pathname primero.
        queueMicrotask(() => client.pageview());
      };

      const origPushState = window.history.pushState;
      const origReplaceState = window.history.replaceState;

      window.history.pushState = function (
        this: History,
        ...args: Parameters<History['pushState']>
      ): void {
        origPushState.apply(this, args);
        fire();
      };

      window.history.replaceState = function (
        this: History,
        ...args: Parameters<History['replaceState']>
      ): void {
        origReplaceState.apply(this, args);
        fire();
      };

      window.addEventListener('popstate', fire);
      window.addEventListener('hashchange', fire);
    },
  });
}
